React = require 'react'
{ Component, PropTypes } = React
{ Button, Table } = require 'react-bootstrap'
moment = require 'moment'
{ LinkContainer } = require 'react-router-bootstrap'
require '../../styles/InProgressObservations'

class InProgressObservationsComponent extends Component
	@propTypes:
		observations: PropTypes.array.isRequired

	render: =>
		{ observations } = @props

		React.createElement("div", {"className": "container in-progress-observations fill-parent"},
			React.createElement("div", {"className": "row"},
				React.createElement("div", {"className": "col-md-12"},
					React.createElement("h2", null, "In-progress Observations"),

					(observations.length > 0 && React.createElement(Table, {"striped": true, "bordered": true},
						React.createElement("thead", null,
							React.createElement("tr", null,
								React.createElement("th", null, "ID"),
								React.createElement("th", null, "Started"),
								React.createElement("th", null, "Teacher"),
								React.createElement("th", null, "Classroom"),
								React.createElement("th", null, "Students"),
								React.createElement("th", null, "Actions")
							)
						),
						React.createElement("tbody", null,
						(observations.map (x) ->
							React.createElement("tr", {"key": (x.id)},
								React.createElement("td", null, (x.id)),
								React.createElement("td", null, (moment.utc(x.created_at).format('dddd M/D/YYYY'))),
								React.createElement("td", null, (x.teacher?.name)),
								React.createElement("td", null, (x.classroom?.description)),
								React.createElement("td", null, (x.students?.map (s) -> React.createElement("div", {"key": (s.id)}, ([s.first_name, s.last_name].join ' ')))),
								React.createElement("td", null, React.createElement(LinkContainer, {"to": ("/observations/#{x.id}")}, React.createElement(Button, {"bsStyle": "info"}, "Resume")))
							)
						)
						)
					)),
					(observations.length == 0 && React.createElement("div", null,
						React.createElement("strong", null, "No in-progress observations")
					))
				)
			)
		)

module.exports = InProgressObservationsComponent



// WEBPACK FOOTER //
// ./~/cjsx-loader!./frontend/olos/js/components/InProgressObservations.cjsx